import { inject, injectable } from "inversify";
import { ILogoutGateway, LogoutResponse } from "./LogoutGateway";
import { DITypes, LocalStorageKeys } from "@/core/@types/types";
import type { HttpClient } from "@/core/services/protocols/types";
import type { IStorage } from "@/core/plugins/storage/Storage";
import { logoutZendeskMessaging } from "@/core/plugins/zendesk/zendeskMessaging";

const baseUrl = "/Home/DoLogout/";

@injectable()
export default class LogoutHttpGateway implements ILogoutGateway {
  @inject(DITypes.FINANCAS_HTTP_CLIENT)
  private httpClient?: HttpClient;

  @inject(DITypes.STORAGE)
  private storage!: IStorage;

  private onLogout(redirectUrl?: string) {
    this.storage.delete(LocalStorageKeys.Token);
    this.storage.delete(LocalStorageKeys.TokenNewHorizons);
    this.storage.delete(LocalStorageKeys.userRules);
    this.storage.delete(LocalStorageKeys.UserProfile);

    window.location.href = redirectUrl && redirectUrl.length > 0 ? redirectUrl : "/";
  }

  async logout(): LogoutResponse {
    let redirectUrl: string | undefined;

    logoutZendeskMessaging();

    try {
      const response = await this.httpClient?.post({
        url: baseUrl,
        config: {
          validateStatus: (status: number) =>
            (status >= 200 && status < 300) || status === 302
        }
      });

      const headers = response?.headers;
      if (headers) {
        const rawLocation = headers["x-location"];
        if (typeof rawLocation === "string") {
          redirectUrl = rawLocation;
        }
      }
    } finally {
      this.onLogout(redirectUrl);
    }
  }
}
